import React, { useEffect, useState } from 'react';
import { checkSessionStatus, getUserInfo, generateTelegramLink, verifyTelegramLink, sendTelegramBroadcastRealtimePortfolio, getTelegramMe, unlinkTelegram, handleAuthInvalidToken } from '../composables/fetchAPI';
import TelegramCodePopup from './TelegramCodePopup'; // Import Popup
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import toast from 'react-hot-toast';
import InstructionTelegram from './InstructionTelegram'; // Import InstructionTelegram
import { MdContentCopy } from 'react-icons/md'; // แนะนำให้ลง react-icons หรือใช้ข้อความธรรมดาก็ได้
import MoonIcon from '../assets/icons/MoonIcon'; // เช็ค Path ให้ตรงกับโฟลเดอร์ของคุณด้วยนะครับ
import SunIcon from '../assets/icons/SunIcon';
// import { useUser } from '../context/UserContext';

const UserBox = ({
  user,
  displayMode,
  setDisplayMode,
}: {
  user?: { name?: string; picture?: string; isAdmin?: boolean; telegramStatus?: string };
  displayMode: string;
  setDisplayMode: (mode: string) => void;
}) => {
  // const { userInfo, refreshUser } = useUser();
  const [localUser, setLocalUser] = useState<{ name?: string; picture?: string; isAdmin?: boolean; telegramStatus?: string }>({});
  const [showOption, setShowOption] = useState(false);
  const [showUnlinkPopup, setShowUnlinkPopup] = useState(false);
  const navigate = useNavigate();
  const [pollingTelegram, setPollingTelegram] = useState(false);
  const [showTelegramPopup, setShowTelegramPopup] = useState(false); // State for Telegram Popup
  const [telegramCode, setTelegramCode] = useState<string | null>(null); // State to hold Telegram code
  const [isHovering, setIsHovering] = useState(false); // State to track hover status

  const { toggleTheme } = useTheme();
  const [isDarkTheme, setIsDarkTheme] = useState(() => {
    return document.documentElement.getAttribute('data-theme') !== 'light';
  });

  const handleThemeToggle = (e: React.MouseEvent) => {
    e.stopPropagation(); // ป้องกันไม่ให้ Dropdown ปิดเมื่อกดเปลี่ยน Theme (ถ้าอยากให้ปิดเมื่อกดด้วย ลบบรรทัดนี้ออกได้ครับ)
    toggleTheme();
    setIsDarkTheme(prev => !prev);
  };

  // ฟังก์ชันสำหรับการ Copy Session ID
  const handleCopySessionId = () => {
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      navigator.clipboard.writeText(sessionId);
      toast.success('คัดลอก Session ID แล้ว');
    } else {
      toast.error('ไม่พบ Session ID ในระบบ');
    }
  };
  // useEffect(() => {
  //   if (!user) {
  //     const fetchUser = async () => {
  //       try {
  //         const info = await getUserInfo();
  //         setLocalUser({
  //           name: info.name || 'Unknown',
  //           picture: info.picture && info.picture.trim() !== ''
  //             ? info.picture
  //             : `https://ui-avatars.com/api/?name=${encodeURIComponent(info.name || 'Unknown')}&background=0D8ABC&color=fff`,
  //           telegramStatus: info.telegramStatus,
  //         });
  //       } catch (error) {
  //         setLocalUser({
  //           name: 'ไม่พบข้อมูล',
  //           picture: 'https://ui-avatars.com/api/?name=Unknown&background=0D8ABC&color=fff',
  //           telegramStatus: undefined,
  //         });
  //       }
  //     };
  //     fetchUser();
  //   }
  // }, [user]);

  // Close showOption after 5 seconds if not hovering
  useEffect(() => {
    if (!showOption) return;

    const timeout = setTimeout(() => {
      if (!isHovering) {
        setShowOption(false);
      }
    }, 3000);

    return () => clearTimeout(timeout);
  }, [showOption, isHovering]);


  useEffect(() => {
    const interval = setInterval(() => {

      if (window.location.pathname === '/login') return;
      
      const fetchSessionStatus = async () => {
        try {
          const sessionStatus = await checkSessionStatus();
          // อัปเดตข้อมูลผู้ใช้ใน localUser
          setLocalUser((prev) => ({
            ...prev,
            name: sessionStatus?.data?.name || 'Unknown',
            picture: sessionStatus?.data?.picture || `https://ui-avatars.com/api/?name=Unknown&background=0D8ABC&color=fff`,
            telegramStatus: sessionStatus?.data?.telegramStatus,
          }));
        } catch (error: any) {
          console.error('Error checking session status:', error);

          // ดึงรหัส Error Code จาก error หลัก (ตามโครงสร้างจริงของ response)
          const errorCode = error?.error?.code;
          console.log("errorCodes", errorCode)
          // ปล่อยให้ handleAuthInvalidToken (จุดกลางใน fetchAPI.ts) ตัดสินใจเอง ว่า errorCode นี้
          // ถือว่า session/token ใช้ไม่ได้จริงๆ หรือเปล่า ถ้าใช่ จะแสดง toast ข้อความเฉพาะของ code นั้น
          // แล้วค่อยเคลียร์ token + redirect ไปหน้า login หลังจากดีเลย์ให้อ่านข้อความก่อน
          // ถ้าเป็น Error อื่นๆ เช่น Cloudflare (502, 504), เน็ตหลุดล้วนๆ จะไม่เข้าเงื่อนไขนี้ ข้ามไปเฉยๆ
          handleAuthInvalidToken(errorCode, error?.error?.th_message);
        }
      };
      fetchSessionStatus();
    }, 60000);

    return () => clearInterval(interval);
  }, []); // อย่าลืมใส่ dependency array ตามเดิมถ้ามี

 useEffect(() => {
  // 1. เช็คจาก localStorage ก่อน
  const cachedUser = localStorage.getItem('userInfo');
  if (cachedUser) {
    setLocalUser(JSON.parse(cachedUser));
  }

  // 2. ถ้าไม่มีข้อมูลใน local หรืออยากให้แน่ใจว่าอัปเดตตลอด ค่อยยิง API
  const fetchUser = async () => {
    try {
      const info = await getUserInfo();
      const userData = {
        name: info.name || 'Unknown',
        picture: info.picture && info.picture.trim() !== ''
          ? info.picture
          : `https://ui-avatars.com/api/?name=${encodeURIComponent(info.name || 'Unknown')}&background=0D8ABC&color=fff`,
        telegramStatus: info.telegramStatus,
        isAdmin: info.isAdmin
      };
      
      setLocalUser(userData);
      localStorage.setItem('userInfo', JSON.stringify(userData)); // อัปเดต Cache
      } catch (error) {
        setLocalUser({
          name: 'ไม่พบข้อมูล',
          picture: 'https://ui-avatars.com/api/?name=Unknown&background=0D8ABC&color=fff',
          telegramStatus: undefined,
        });
      }
    };
    fetchUser();

  }, []);

  // const displayUser = {
  //   name: userInfo?.name || 'Unknown',
  //   picture: userInfo?.picture || `https://ui-avatars.com/api/?name=User&background=0D8ABC&color=fff`,
  //   telegramStatus: userInfo?.telegramStatus,
  //   isAdmin: userInfo?.isAdmin
  // };
  const displayUser = user || localUser;

  // กดปุ่ม "ยกเลิก Telegram" จะเปิด Popup
  const handleTelegramUnlink = () => {
    setShowUnlinkPopup(true);
  };

  // กดยืนยันใน Popup
  const confirmUnlinkTelegram = async () => {
    try {
      const telegramMe = await getTelegramMe();
      const telegramId = telegramMe?.data.telegramId || telegramMe?.telegram_id;
      if (!telegramId) {
        toast.error('ไม่พบ telegramId');
        setShowUnlinkPopup(false);
        return;
      }
      await unlinkTelegram(telegramId);
      setShowUnlinkPopup(false);
      // อัปเดตข้อมูล user ใหม่ทั้งหมด
      const info = await getUserInfo();
      setLocalUser({
        name: info.name || 'Unknown',
        picture: info.picture && info.picture.trim() !== ''
          ? info.picture
          : `https://ui-avatars.com/api/?name=${encodeURIComponent(info.name || 'Unknown')}&background=0D8ABC&color=fff`,
        telegramStatus: info.telegramStatus,
        isAdmin: info.isAdmin,
      });
      toast.success('ยกเลิก Telegram สำเร็จ');
    } catch (error) {
      toast.error('เกิดข้อผิดพลาดในการยกเลิก Telegram');
      setShowUnlinkPopup(false);
    }
  };

  // กดยกเลิกใน Popup
  const cancelUnlinkTelegram = () => {
    setShowUnlinkPopup(false);
  };

const handleLogout = () => {
    localStorage.removeItem('userInfo'); // ✅ เพิ่มบรรทัดนี้

  localStorage.removeItem('token');
  navigate('/login');
};

  // const handleTelegramConnect = async () => {
  //   try {
  //     window.open(`${process.env.REACT_APP_TELEGRAM_BOT}?startapp=hello`, '_blank');
  //     setPollingTelegram(true); // เริ่ม polling
  //   } catch (error) {
  //     console.error('Failed to generate Telegram link:', error);
  //   }
  // };
  const handleTelegramConnect = async () => {
    try {
      setShowTelegramPopup(true); // Show the Telegram Popup
    } catch (error) {
      console.error('Failed to generate Telegram link:', error);
    }
  };

  const navigateToTelegram = () => {
    // window.open(`${process.env.REACT_APP_TELEGRAM_BOT}?startapp=${telegramCode}`, '_blank');
    window.open(`${process.env.REACT_APP_TELEGRAM_BOT}`, '_blank');
    setPollingTelegram(true); // Start polling
    setShowTelegramPopup(false); // Close the popup
  };
  // Poll สถานะ telegramStatus ทุก 2 วินาที หลังจากกด Join Telegram
  useEffect(() => {
    if (!pollingTelegram) return;
    const interval = setInterval(async () => {
      const info = await getUserInfo();
      setLocalUser((prev) => ({
        ...prev,
        telegramStatus: info.telegramStatus,
      }));
      if (info.telegramStatus === 'linked') {
        setPollingTelegram(false);
        clearInterval(interval);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [pollingTelegram]);



  return (
    <div className="relative"
      onMouseEnter={() => setIsHovering(true)} // Set hovering to true
      onMouseLeave={() => setIsHovering(false)} // Set hovering to false
    >
      <div
        className="flex items-center  bg-opacity-80 rounded-lg px-4 py-2 shadow  cursor-pointer hover:bg-gray-800 transition-all"
        onClick={() => setShowOption((prev) => !prev)}
        style={{ minWidth: 0, backgroundColor: 'var(--button-userbox)' }}
      >
        <img
          src={displayUser.picture}
          alt="User Avatar"
          className="w-7 h-7 rounded-full border border-gray-600 mr-2"
        />
        <span className="font-bold text-sm truncate max-w-[50px]"
          style={{ color: 'var(--text-color)' }}
        >{displayUser.name}</span>
      </div>

      <div
        className={`absolute left-0 right-0 mt-2 bg-[var(--component-bg-color)] flex flex-col gap-2 z-10 overflow-hidden transition-[max-height] duration-500 ease-in-out ${showOption ? 'max-h-96' : 'max-h-0'
          }`}
      >
        {displayUser.telegramStatus === 'linked' ? (
          <div
            className="bg-red-400 text-white rounded shadow px-3 py-1 cursor-pointer text-center text-sm flex items-center justify-center gap-2"
            onClick={handleTelegramUnlink}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
              alt="Telegram Icon"
              className="w-4 h-4"
            />
            <span>ยกเลิก Telegram</span>
          </div>
        ) : (
          <div
            className="bg-white  text-black border border-black rounded shadow px-3 py-1 cursor-pointer text-center text-sm flex items-center justify-center gap-2"
            onClick={handleTelegramConnect}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
              alt="Telegram Icon"
              className="w-4 h-4"
            />
            <span>Join Telegram</span>
          </div>
        )}

        {/* --- ส่วนที่เพิ่มใหม่: Copy Session ID --- */}
        {user?.isAdmin && (
          <div
            className="bg-gray-100 text-gray-800 rounded shadow px-3 py-1 cursor-pointer text-center text-sm flex items-center justify-center gap-2 hover:bg-gray-200 transition-colors"
            onClick={handleCopySessionId}
          >
            {/* คุณสามารถใช้ emoji แทน icon ได้ถ้าไม่ได้ลง react-icons */}
            <span>📋</span>
            <span>Session ID</span>
          </div>

        )}

        <div className="md:hidden flex flex-col gap-2 mb-2">
          <div className="flex bg-gray-800 p-1 rounded-lg">
            <button
              onClick={() => setDisplayMode?.('V1')}
              className={`flex-1 py-1 text-xs font-bold rounded ${displayMode === 'V1' ? 'bg-yellow-500 text-black' : 'text-gray-400'}`}
            >
              โหมดง่าย
            </button>
            <button
              onClick={() => setDisplayMode?.('V2')}
              className={`flex-1 py-1 text-xs font-bold rounded ${displayMode === 'V2' ? 'bg-yellow-500 text-black' : 'text-gray-400'}`}
            >
              โหมดแม่นยำ
            </button>
          </div>
        </div>



        {/* --- ส่วนที่เพิ่มใหม่: Theme Toggle --- */}
        <div
          className="bg-gray-100 text-gray-800 rounded shadow px-3 py-1 cursor-pointer text-center text-sm flex items-center justify-center gap-2 hover:bg-gray-200 transition-colors"
          onClick={handleThemeToggle}
        >
          {isDarkTheme ? <SunIcon size={16} /> : <MoonIcon size={16} />}
          <span>{isDarkTheme ? 'Light Mode' : 'Dark Mode'}</span>
        </div>
        {/* -------------------------------------- */}


{/* --- 🌟 ส่วนที่เพิ่มใหม่: ปุ่มช่วยเหลือ (FAQ) แสดงเฉพาะบน Mobile (md:hidden) --- */}
        <div
          className="md:hidden bg-blue-50 text-blue-700 border border-blue-200 rounded shadow px-3 py-1.5 cursor-pointer text-center text-sm flex items-center justify-center gap-2 hover:bg-blue-100 transition-colors font-bold"
          onClick={() => {
            setShowOption(false);
            navigate('/faq');
          }}
        >
          <span className="w-5 h-5 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs shadow-sm">?</span>
          <span>ช่วยเหลือ (FAQ)</span>
        </div>
        {/* -------------------------------------- */}





        <div
          className="bg-red-600 text-white rounded shadow px-3 py-1 cursor-pointer text-center text-sm"
          onClick={handleLogout}
        >
          Log out
        </div>
      </div>

      {/* Popup ยืนยันการยกเลิก Telegram */}
      {showUnlinkPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="rounded-lg shadow-lg p-6 w-80" style={{ backgroundColor: 'var(--button-userbox)' }}>
            <div className="text-lg font-bold mb-4 text-center" style={{ color: 'var(--text-color)' }}>คุณต้องการจะยกเลิกการเชื่อมต่อกับ Telegram ใช่มั้ย?</div>
            <style>
              {`
@keyframes bounce-telegram {
  0%, 100% { transform: translateY(0);}
  30% { transform: translateY(-6px);}
  50% { transform: translateY(-12px);}
  70% { transform: translateY(-6px);}
}
.bounce-telegram {
  animation: bounce-telegram 2s infinite;
}
`}
            </style>
            {/* รูป Telegram */}
            <img
              src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
              alt="Telegram"
              className="w-16 h-16 mb-4 items-center mx-auto bounce-telegram"
            />

            <div className="flex justify-between mt-6">
              <button
                className="bg-gray-300 px-4 py-2 rounded text-black"
                onClick={cancelUnlinkTelegram}
              >
                ยกเลิก
              </button>
              <button
                className="px-4 py-2 rounded text-white"
                style={{ backgroundColor: 'var(--green-text-color)' }}
                onClick={confirmUnlinkTelegram}
              >
                ตกลง
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Telegram Code Popup */}
      {showTelegramPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowTelegramPopup(false)}>

          <InstructionTelegram />

          <TelegramCodePopup
            onClose={() => setShowTelegramPopup(false)}
            onNavigateToTelegram={navigateToTelegram}
            setTelegramCode={setTelegramCode}
          />
        </div>
      )}

    </div>
  );
};

export default UserBox;